import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/myself/mima.png'
import _imports_1 from '@/assets/myself/kaoqin.png'
import _imports_2 from '@/assets/myself/xiangmu.png'
import _imports_3 from '@/assets/myself/tongzhi.png'
import _imports_4 from '@/assets/myself/rukou.png'
import _imports_5 from '@/assets/myself/tuichu.png'


const _withScopeId = n => (_pushScopeId("data-v-c910c418"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "userinfo-content" }
const _hoisted_2 = { class: "userinfo-name" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "photobox" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "userinfo-data" }
const _hoisted_7 = { class: "num" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nape" }, "我的项目", -1))
const _hoisted_9 = { class: "num" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nape" }, "考勤天数", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listicon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listicon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listicon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listicon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listicon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_16 = { class: "selectbox" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr" }, "项目", -1))
const _hoisted_18 = { class: "selectbox" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr" }, "总部", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "listicon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["settinglist", _ctx.classList]),
    onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.touchStart && _ctx.touchStart(...args))),
    onTouchmove: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.touchMove && _ctx.touchMove(...args))),
    onAnimationend: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.animationend && _ctx.animationend(...args)))
  }, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$route.meta.title
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.userInfo.name), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "photo",
            src: _ctx.userInfo.photoUrl
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$store.state.project.projectList.length), 1),
          _hoisted_8
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.checkCount), 1),
          _hoisted_10
        ])
      ])
    ]),
    _createVNode(_component_van_cell, {
      title: "修改密码",
      "is-link": "",
      onClick: _ctx.goChangePassworld
    }, {
      icon: _withCtx(() => [
        _hoisted_11
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_van_cell_group, { class: "mb" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell, {
          title: "我的考勤",
          "is-link": "",
          onClick: _ctx.fGoMyDuty
        }, {
          icon: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_van_cell, {
          title: "我的项目",
          "is-link": "",
          onClick: _ctx.fGoMyProject
        }, {
          icon: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_van_cell, {
          title: "通知公告",
          "is-link": "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/mynotice')))
        }, {
          icon: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_cell_group, { class: "mb" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell, { title: "当前入口" }, {
          icon: _withCtx(() => [
            _hoisted_15
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_van_checkbox, {
                disabled: _ctx.$store.state.user.userInfo.type === 1,
                modelValue: _ctx.isProjectEntry,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isProjectEntry) = $event)),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fSelectEntry(1)))
              }, null, 8, ["disabled", "modelValue"])
            ])
          ]),
          _: 1
        }),
        (_ctx.$store.state.user.userInfo.type !== 1)
          ? (_openBlock(), _createBlock(_component_van_cell, {
              key: 0,
              title: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_van_checkbox, {
                    modelValue: _ctx.isGeneralEntry,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isGeneralEntry) = $event)),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fSelectEntry(2)))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_van_cell, {
      title: "退出登录",
      clickable: "",
      onClick: _ctx.fSignOut
    }, {
      icon: _withCtx(() => [
        _hoisted_20
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 34))
}